import { CustomButton, CustomLabel } from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import styled from "styled-components";

interface IStyledProps {
  bgColor?: string;
  color?: string;
}
const NotificationOuterWrapper = styled.div`
  padding: 20px 30px 0px 0px;
`;

const NotificationWrapper = styled.div<IStyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.bgColor || "#EBF5FF"};
  border: 1px solid ${(props) => props.color || "#556BB8"};
  border-radius: 10px;
  padding: 12px 30px;
  cursor: pointer;
  font-size: 12px;

  ${CustomLabel} {
    color: ${(props) => props.color || "#555555"};
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
  }
  ${CustomButton} {
    background-color: ${(props) => props.color || "#FFFFFF"};
    color: ${(props) => props.bgColor || " #556bb8"};
    font-size: 16px;
    font-weight: 400;
    padding: 7px 15px;
    border: 1px solid ${(props) => props.color || "#556BB8"};
    border-radius: 6px;
  }
`;

interface IProps {
  descripton?: string;
  buttonCaption?: string;
  onClick?: () => void;
  bgColor?: string;
  color?: string;
  buttonBgColor?: string;
  buttonColor?: string;
  borderColor?: string;
}

const NotificationBox: FC<IProps> = ({
  descripton,
  buttonCaption,
  onClick,
  bgColor,
  color,
}) => {
  return (
    <NotificationOuterWrapper>
      <NotificationWrapper bgColor={bgColor || ""} color={color || ""}>
        <CustomLabel>{descripton}</CustomLabel>
        <CustomButton onClick={() => onClick && onClick()}>
          {buttonCaption}
        </CustomButton>
      </NotificationWrapper>
    </NotificationOuterWrapper>
  );
};

export default NotificationBox;

// Only bgColor and color are used in the styled component and will manage the complete UI of the component.
